import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useData } from "../../contexts/DataContext";
import { fetchBlog } from "../../services/ApiService";
import { Blog } from "../../models/Blog";
import { Spin } from "antd";

const BlogPost: React.FC = () => {
  const { blogPostPath } = useParams<{ blogPostPath: string }>();
  const [post, setPost] = useState<Blog | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [embedHtml, setEmbedHtml] = useState<string>("");
  const { state, dispatch } = useData();

  const loadEmbedCode = async (embedCodeUrl: string) => {
    try {
      const response = await fetch(embedCodeUrl);
      if (!response.ok) {
        throw new Error("Failed to load embed code");
      }
      const scriptContent = await response.text();
      // Capture the value of E which contains the HTML embed from the script content using regex
      const eMatch = scriptContent.match(/(?:var|const|let)?\s*E\s*=\s*(['"`])([\s\S]*?)\1(?=\s*,\s*F=|\s*;|\s*$)/m);

      // keep the HTML in React state so we don't rely on DOM timing or manual mutation
      setEmbedHtml(eMatch ? eMatch[2] : "Failed to load blog post");
    } catch (error) {
      console.error("Error loading embed code:", error);
    }
  };

  useEffect(() => {
    const loadBlog = async () => {
      setLoading(true);

      // Check if the blog post is already in the state
      let blogPost = state.blogs?.find(
        (element) => element.blog_url_path === blogPostPath
      );

      // If the blog post is not in the state, fetch it
      if (!blogPost) {
        blogPost = await fetchBlog(blogPostPath!);
      }

      if (blogPost) {
        setPost(blogPost);
        if (blogPost.PicTime_Blog_Embed_Code) {
          await loadEmbedCode(blogPost.PicTime_Blog_Embed_Code);
        }
      } else {
        console.error("Blog post not found");
      }

      setLoading(false);
    };

    loadBlog();
  }, [blogPostPath, state.blogs, dispatch]);

  if (loading) {
    return (
      <div
        id="loading-section"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "50vh",
        }}
      >
        <Spin size="large" style={{ fontSize: 48 }} />
      </div>
    );
  }

  if (!post) {
    return <div>Blog post not found</div>;
  }

  return (
    <div
      id="portfolio-section"
      dangerouslySetInnerHTML={{ __html: embedHtml }}
    />
  );
};

export default BlogPost;